import { useState } from 'react'
import CategoryTable from '../../Molecules/CategoryTable/CategoryTable';
import GroupOfButtons from '../../Molecules/GroupOfButtons/GroupOfButtons';
import HeaderTitle from '../../Molecules/HeaderTitle/HeaderTitle'



const ManageCategories = () => {

  const [formsHandler, setFormsHandler] = useState({
    showForm1: true,
    showForm2: false,
  });


  return (
    <div className="nd-grid main-home">
      <HeaderTitle headerText="Gestionar categorías" />
      <div className="mt-30 mb-20">
        <GroupOfButtons
          content={{
            first: "Activos",
            second: "Inactivos",
          }}
          formsHandler={formsHandler}
          setFormsHandler={setFormsHandler}
        />
      </div>
      <div className="box s-pxy-20 m-pxy-50 mt-30 mb-20">
        <p className="source-24 mb-20">Categorías { formsHandler.showForm1 ? 'activas' : 'inactivas'}</p>
        <div className="mt-20 table-container">
          {
            formsHandler.showForm1 && <CategoryTable />
          }
          {
            formsHandler.showForm2 && <CategoryTable />
          }
        </div>
      </div>
    </div>
  )
}

export default ManageCategories
